export default function CoreV5WithCoreV4() {
  return (
    <iframe
      title="codesandbox"
      src="https://codesandbox.io/embed/https-mui-com-x-migration-migration-data-grid-v4-24ltxx?hidenavigation=1&fontsize=14&view=preview"
      style={{
        width: '100%',
        height: 520,
        border: 0,
      }}
      sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"
    />
  );
}
